<ng-http-loader
  [backdrop]="false"
  [debounceDelay]="400"
  [filteredUrlPatterns]="['KeepAlive']"
  [entryComponent]="loadSpinner"
></ng-http-loader>

<app-header *ngIf="showBookingLayout && initialDataLoaded"></app-header>

<router-outlet *ngIf="cookiesSupported"></router-outlet>

<!-- Safari doesn't support Cookies in iFrame, then we show a link to open 2reserve in a new window -->
<div *ngIf="!cookiesSupported && initialDataLoaded" class="no-cookie-support">
  <a mat-stroked-button target="_blank" [routerLink]="[catalog!.name]">{{ 'IFRAME_WITHOUT_COOKIE_SUPPORT' | translate }}</a>
</div>

<div *ngIf="initialDataLoadError" class="app-loading">
  <mat-error *ngIf="initialDataLoadError === 'OrderNotFound'" translate="ERROR.ORDER_NOT_FOUND"></mat-error>
</div>

<app-footer *ngIf="showBookingLayout && showFooter && initialDataLoaded"></app-footer>
